// extracted by mini-css-extract-plugin
export var standaloneTable = "_z-0";
export var standaloneTableWithBodyFill = "_z-1";
export var withExtraHeader = "_z-2";